// Onderdelen: de bezoeker kiest zijn apparaat en ziet meteen of dit onderdeel past.
// De antwoorden staan al in de HTML (vertaald, per apparaat); dit script toont alleen het juiste antwoord.

class PartFitCheck extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-fit-select]');
    if (!this.select) return;
    this.results = [...this.querySelectorAll('[data-result]')];
    this.hidden = false;
    this.select.addEventListener('change', () => this.update());
    this.update();
  }

  update() {
    const value = this.select.value;
    this.results.forEach((result) => {
      result.hidden = result.dataset.result !== value;
    });
  }
}

if (!customElements.get('part-fit-check')) customElements.define('part-fit-check', PartFitCheck);
